/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { PreloadAllModules, Route, RouterModule, Routes } from '@angular/router';
import { EPath } from '@app/@core/enums/path.enum';
import { MailTokenTypeEnum } from '@common/enums/mail-token-type.enum';
import { OrganizationRolesEnum } from '@common/enums/organization-roles.enum';
import { metaGuard } from '@core/meta-data/meta.guard';

interface IAppRoute extends Omit<Route, 'data'> {
  data?: {
    showTabs?: boolean;
    backBtnPath?: EPath[] | null;
    meta?: {
      title: string;
      description?: string;
      override?: true;
    };
    restrictToRoles?: OrganizationRolesEnum[];
    tokenType?: MailTokenTypeEnum;
    canAccessUnpaid?: true;
  };
  children?: IAppRoute[];
}

export type AppRoutesType = IAppRoute[];

const routes: Routes = [
  {
    path: '',
    redirectTo: EPath.Login,
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('@modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: EPath.WorkspaceSelector,
    canActivateChild: [metaGuard],
    loadChildren: () =>
      import('./@modules/workspace-selector/organization-selector.module').then(
        (m) => m.OrganizationSelectorModule,
      ),
  },
  {
    path: EPath.NotFound,
    canActivateChild: [metaGuard],
    children: [
      {
        path: '**',
        loadChildren: () =>
          import('@modules/not-found/not-found.module').then((m) => m.NotFoundModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: EPath.Login,
    canActivateChild: [metaGuard],
  },
] satisfies AppRoutesType;

export const AppRoutes = RouterModule.forRoot(routes, {
  initialNavigation: 'disabled',
  preloadingStrategy: PreloadAllModules,
  anchorScrolling: 'enabled',
});
